module.exports = __webpack_public_path__ + "static/9-1a716a5b78466e836f43243af219e685.jpg";